module.exports = __webpack_public_path__ + "img/3.642a29a1.jpg";